// SPDX-License-Identifier: GPL-3.0-only
// Copyright (C) 2026 Kyle Johnson
// This file is part of Hushold.
//
// Hushold is free software: you can redistribute it and/or modify
// it under the terms of the GNU General Public License as
// published by the Free Software Foundation, version 3.

// Build stamp for the running client. The values are injected by Vite's
// `define` (see vite.config.ts): version from package.json, commit from
// `git rev-parse --short HEAD` (or the GIT_COMMIT env var). The `typeof`
// guards keep non-Vite runtimes (vitest with its own config) working with
// sensible dev fallbacks instead of a ReferenceError.

declare const __APP_VERSION__: string | undefined;
declare const __GIT_COMMIT__: string | undefined;

export const APP_VERSION: string =
  typeof __APP_VERSION__ === 'string' ? __APP_VERSION__ : '0.0.0-dev';

export const GIT_COMMIT: string = typeof __GIT_COMMIT__ === 'string' ? __GIT_COMMIT__ : 'unknown';

/** "0.1.0 (a1b2c3d)" — the canonical human-readable build stamp. */
export const BUILD_STAMP = `${APP_VERSION} (${GIT_COMMIT})`;
